// Packages
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// Components
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Forum from "./pages/Forum";
import Thread from "./pages/Thread";
import ManagePanel from "./pages/ManagePanel";
import RequiredAuth from "./components/routing/RequiredAuth";
import CreateThread from "./pages/CreateThread";
import NotFound from "./pages/NotFound";
import CreateTopic from "./pages/admin/CreateTopic";
import DeleteTopic from "./pages/admin/DeleteTopic";
import BanUser from "./pages/admin/BanUser";
import UnbanUser from "./pages/admin/UnbanUser";
import ChangePassword from "./pages/ChangePassword";
import ResetPassword from "./pages/ResetPassword";
import About from "./pages/About";

// Assets
import "./App.css";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/resetPassword" element={<ResetPassword />} />

        <Route element={<RequiredAuth allowedRoles={["user", "admin"]} />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/changePassword" element={<ChangePassword/>} />
          <Route path="/forum/:topicId" element={<Forum />} />
          <Route path="/forum/:topicId/createthread" element={<CreateThread />} />
          <Route path="/forum/:topicId/:threadId" element={<Thread />} />
        </Route>

        <Route element={<RequiredAuth allowedRoles={["admin"]} />}>
          <Route path="/admin/createTopic" element={<CreateTopic/>} />
          <Route path="/admin/deleteTopic" element={<DeleteTopic/>} />
          <Route path="/admin/banUser" element={<BanUser/>} />
          <Route path="/admin/unbanUser" element={<UnbanUser/>} />
        </Route>

        <Route element={<RequiredAuth allowedRoles={["accManager"]} />}>
          <Route path="/managePanel" element={<ManagePanel/>} />
        </Route>

        <Route path="*" element={<NotFound/>} />

      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
